/**
 * Control segmentado compacto (opciones excluyentes), p. ej. Kanban/Tabla.
 *
 * @component
 * @param {Object} props
 * @param {Array<{value: string, label?: string, icon?: string, title?: string, count?: number}>} props.options
 *   Si una opción no tiene `label`, se muestra sólo el ícono (con `title` como ayuda).
 *   `count` muestra un contador junto a la etiqueta.
 * @param {string} props.value - Opción seleccionada.
 * @param {(value: string) => void} props.onChange
 * @param {string} [props.ariaLabel]
 * @returns {JSX.Element}
 */
const SegmentedControl = ({ options, value, onChange, ariaLabel }) => (
  <div className="seg" role="radiogroup" aria-label={ariaLabel}>
    {options.map((opt) => {
      const active = opt.value === value
      return (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={active}
          aria-label={opt.label ? undefined : opt.title}
          title={opt.title || opt.label}
          className={`seg-btn ${active ? 'is-active' : ''}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.icon && <i className={opt.icon} />}
          {opt.label && <span>{opt.label}</span>}
          {opt.count !== undefined && (
            <span className="seg-count">{opt.count}</span>
          )}
        </button>
      )
    })}

    <style>{`
      .seg {
        display: inline-flex; gap: 2px; padding: 2px; height: 34px;
        border: 1px solid var(--gm-border); border-radius: 8px; background: var(--gm-surface-2);
      }
      .seg-btn {
        display: inline-flex; align-items: center; gap: 6px; padding: 0 10px;
        border: none; border-radius: 6px; background: transparent;
        color: var(--gm-text-muted); font-size: 0.8rem; font-weight: 500;
      }
      .seg-btn i { font-size: 0.78rem; }
      .seg-btn:hover { color: var(--gm-text); }
      .seg-count {
        min-width: 18px; padding: 0 5px; border-radius: 99px; text-align: center;
        font-size: 0.68rem; font-weight: 600; font-variant-numeric: tabular-nums;
        background: var(--gm-surface-2); color: var(--gm-text-muted);
      }
      .seg-btn.is-active .seg-count { background: var(--gm-primary-soft); color: var(--gm-primary); }
      .seg-btn.is-active {
        background: var(--gm-surface); color: var(--gm-text);
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
      }
    `}</style>
  </div>
)

export default SegmentedControl
